import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { FormAwsComponent } from './form/form-aws/form-aws.component';
import { HomeComponent } from './home-page/home-page.component';
import { FormAzureComponent } from './form/form-azure/form-azure.component';


const routes: Routes = [  
  { path: '', component: HomeComponent },
  { path: 'home', component: HomeComponent, pathMatch: 'full' },
  // { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'form/aws', component : FormAwsComponent}, //FormComponent = AWS form component 
  {path: 'form/azure', component: FormAzureComponent},

  { path: '**', redirectTo: '', pathMatch: 'full' },
  ]; 
  

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
